import React, {Component} from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import EmailLoginForm from './EmailLoginForm';
import Copyright from '../common/Copyright';
import Translation from '../common/Translation';

export default class Quicklogin extends Component {
    constructor() {
        super();
        this.state = {
            message: '',
            buttonText: ''
        };
    }

    static get getMessage() {
        return 'Введите свой e-mail для входа на вебинар';
    }

    static get getButtonText() {
        return 'Вход';
    }

    setDefaultMessage() {
        this.setState({
            message: Quicklogin.getMessage,
            buttonText: Quicklogin.getButtonText
        });
    }

    componentDidMount() {
        const lang = new URLSearchParams(window.location.search).get('lang');

        Translation.translate([Quicklogin.getMessage, Quicklogin.getButtonText], lang, (translation) => {
                this.setState({
                    message: translation[Quicklogin.getMessage],
                    buttonText: translation[Quicklogin.getButtonText],
                });
            }, () => {
                this.setDefaultMessage();
            }
        );
    }

    render() {
        return (
            <Container maxWidth="sm">
                <Box my={4}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        {this.state.message}
                    </Typography>
                    <EmailLoginForm buttonText={this.state.buttonText}/>
                    <Copyright/>
                </Box>
            </Container>
        );
    }
}
